import { filterUtterancesWithValidDuration, getLocationAndWidth, utterancePillSimplifier } from './mediaTimelineUtils';
import { getParticipantDomainFromEmail } from './mediaParticipantListUtils';
import { USER } from '../constants/CallParticipantTypes';
function getSpeakerTimelinePillColor(speaker, hostParticipant) {
  // handle the case when speaker or host is not mapped
  if (!speaker.email || !hostParticipant || !hostParticipant.email) {
    return 'fill-accent-neutral-default';
  }
  const hostCompany = getParticipantDomainFromEmail(hostParticipant.email);
  const participantCompany = getParticipantDomainFromEmail(speaker.email);
  if (hostCompany === participantCompany) {
    return 'fill-accent-light-orange-default';
  }
  return 'fill-accent-purple-default';
}
export function getSpeakerTimelinePills(utterances, speaker, durationInSeconds, hostParticipant) {
  return utterances.map((utterancePill, index) => {
    const locationAndWidth = getLocationAndWidth(utterancePill.startTimeSeconds, utterancePill.endTimeSeconds, durationInSeconds, true);
    const startLocation = locationAndWidth.startLoc;
    const width = locationAndWidth.width;
    const color = getSpeakerTimelinePillColor(speaker, hostParticipant);
    return {
      id: index,
      startLocation,
      width,
      borderColor: color,
      fillColor: color
    };
  });
}
export function getSpeakerTimeline(speakersData, durationInSeconds) {
  // Find the sales rep on the call
  const hostParticipant = speakersData.find(speaker => speaker.callParticipantType === USER) || null;
  return speakersData.map(speaker => {
    // filter utterances with valid start time and end time
    const filteredSpeakerTimeline = filterUtterancesWithValidDuration(speaker.utterances, durationInSeconds);

    // get simplified timeline with close pills merged together
    const simplifiedSpeakerTimeline = utterancePillSimplifier({
      pills: filteredSpeakerTimeline,
      durationInSeconds
    });

    // generate pill data for timeline component
    const speakerPills = getSpeakerTimelinePills(simplifiedSpeakerTimeline, speaker, durationInSeconds, hostParticipant);
    return {
      speaker,
      speakerPills
    };
  });
}